import * as PropTypes from "prop-types";

import stackedSliderStyles from "./StackedSlider.css";

import { HeadingSubHeader, HeadingHeader } from "/react/library/";

export class StackedSliderCaption extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    caption: PropTypes.string.isRequired,
    hideOnMobile: PropTypes.bool,
  };

  render() {
    const { title, caption, hideOnMobile } = this.props;

    return (
      <div
        className={
          hideOnMobile
            ? stackedSliderStyles.captionHiddenMobile
            : stackedSliderStyles.caption
        }
      >
        {title && (
          <HeadingSubHeader isLight className={stackedSliderStyles.title}>
            {title}
          </HeadingSubHeader>
        )}
        <HeadingSubHeader
          isLight
          className={
            hideOnMobile
              ? stackedSliderStyles.subtitleHiddenMobile
              : stackedSliderStyles.subtitle
          }
        >
          {caption}
        </HeadingSubHeader>
      </div>
    );
  }
}
